import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadWidgetBox from "./LoadWidgetBox";
import { Row, Col } from "react-bootstrap";
import { groupBy } from "../../../helpers/common";
import { setMainLoadViewType } from "../../../actions/dashboard";

const LoadWidgetBoxList = () => {
	const dispatch = useDispatch();
	const loadHistory = useSelector((state) => state.dashboard.loads.loadHistory.payload);
	const dynamicLoadGraphData = useSelector((state) => state.dashboard.loads.loadHistory.dynamicLoadGraphData);
	const viewTypes = useSelector((state) => state.dashboard.loads.viewTypes);
	const viewId = useSelector((state) => state.dashboard.loads.viewId);
	const selectedPlanType = useSelector((state) => state.plan.selectedPlanType);

	const viewLoadTypes = useMemo(() => {
		let viewList = viewTypes;
		if (selectedPlanType === 2) {
			viewList = viewList.filter((item) => item.id !== 4);
		}
		return viewList;
	}, [viewTypes, selectedPlanType]);

	const getLoadCount = (keyName, id) => {
		if (!keyName) return loadHistory.length;
		if (selectedPlanType === 2) {
			if (id === 1) {
				let fieldCount = [];
				dynamicLoadGraphData.forEach((load) => {
					const payload = {
						loadDate: load.created_date_tz,
						loadCapacity: load.load_capacity,
						sourceEquipmentGroupId: load.source_equipment_group_uuid,
						sourceEquipmentGroupName: load.source_equipment_group_name,
						targetEquipmentGroupId: load.target_equipment_group_uuid,
						targetEquipmentGroupName: load.target_equipment_group_name,
						fieldGeoShapeId: load.geo_shape_uuid,
						fieldGeoRegionName: load.geo_shape_name,
					};
					fieldCount.push(payload);
				});
				return Object.keys(groupBy(keyName)(fieldCount)).length;
			} else if (id === 2) {
				let implementCount = [];
				dynamicLoadGraphData.forEach((load) => {
					const payload = {
						loadDate: load.created_date_tz,
						loadCapacity: load.load_capacity,
						sourceEquipmentGroupId: load.target_equipment_group_uuid,
						sourceEquipmentGroupName: load.target_equipment_group_name,
						targetEquipmentGroupId: load.source_equipment_group_uuid,
						targetEquipmentGroupName: load.source_equipment_group_name,
						fieldGeoShapeId: load.geo_shape_uuid,
						fieldGeoRegionName: load.geo_shape_name,
					};
					implementCount.push(payload);
				});
				return Object.keys(groupBy(keyName)(implementCount)).length;
			} else {
				return Object.keys(groupBy(keyName)(loadHistory)).length;
			}
		} else {
			return Object.keys(groupBy(keyName)(loadHistory)).length;
		}
	};
	return (
		<Row className="load-count-list">
			{viewLoadTypes.map((item) => (
				<Col className="p-0" key={item.id}>
					<LoadWidgetBox id={item.id} title={item.name.toUpperCase()} icon={item.icon} primaryColor={item.primaryColor} secondaryColor={item.secondaryColor} loadCount={getLoadCount(item.keyName, item.id)} selected={viewId === item.id} onClick={(id) => dispatch(setMainLoadViewType(id))} />
				</Col>
			))}
		</Row>
	);
};

export default LoadWidgetBoxList;
